import { PExt } from "components/myTags/myTags"
import { useEffect, useRef } from "react"
import { Colors } from "styles/colors"

interface IProps {
    next: () => void
    previous: () => void
    pageNumber: number
    totalPages: number
    close: ()=>void
    timer?:number
}

export default function PagesControl({ next, previous, pageNumber, totalPages, timer, close }: IProps) {
    
    useEffect(() => {
        let timeout: NodeJS.Timeout
        if (timer) {
            timeout = setInterval(() => {
                next()
            }, timer)
        }

        return () => {
            clearTimeout(timeout)
        }
    }, [pageNumber])

    return (
        <div id="pages-control">
            <button type='button' disabled={pageNumber <= 0} onClick={previous}>
                <p>❰</p>
            </button>
            <PExt fontSize='20px' color={Colors.gris1}>
                &nbsp;&nbsp;&nbsp;Page {pageNumber + 1 || (totalPages ? 1 : '--')} /{' '}
                {totalPages || '--'}&nbsp;&nbsp;&nbsp;
            </PExt>
            <button type='button' disabled={pageNumber > totalPages} onClick={next} style={{ transform: 'rotate(180deg)' }}>
                <p>❰</p>
            </button>
            <div id="close-button" onClick={() => {
                close()
            }}>
                FERMER
            </div>
        </div>
    )
}